// removed by extract-text-webpack-plugin
module.exports = {"root":"_1L5OJ","copyright":"_3N0zG","link":"xgO1H","separator":"_3Y3wN"};


//////////////////
// WEBPACK FOOTER
// ./src/App/AppFooter.css
// module id = 494
// module chunks = 3